/**
 * LAZY LOADING PATCH - AGREGA LAZY LOADING A TODO LO QUE FALTA
 * Este script se ejecuta una sola vez al cargar y parchea todo
 */

(function() {
  'use strict';

  console.log('🔧 Lazy Loading Patch iniciando...');

  // ============================================
  // 1. PARCHEAR TODAS LAS IMÁGENES SIN LAZY
  // ============================================
  
  const patchAllImages = () => {
    let patchedCount = 0;
    
    // Seleccionar TODAS las imágenes sin loading o con loading="eager"
    const images = document.querySelectorAll('img:not([loading="lazy"]), img[loading="eager"]');
    
    images.forEach((img, index) => {
      // Skip primeras 2 imágenes (above the fold - hero/banner)
      if (index < 2) {
        img.loading = 'eager';
        img.fetchpriority = 'high';
        img.decoding = 'async';
        return;
      }
      
      // Resto de imágenes → lazy
      img.loading = 'lazy';
      img.decoding = 'async';
      
      // Si no tiene width/height, calcular del estilo
      if (!img.hasAttribute('width') && img.offsetWidth > 0) {
        img.width = img.offsetWidth;
        img.height = img.offsetHeight;
      }
      
      patchedCount++;
    });
    
    return patchedCount;
  };

  // ============================================
  // 2. PARCHEAR TODOS LOS IFRAMES
  // ============================================
  
  const patchAllIframes = () => {
    let patchedCount = 0;
    
    document.querySelectorAll('iframe:not([loading])').forEach(iframe => {
      iframe.loading = 'lazy';
      patchedCount++;
    });
    
    return patchedCount;
  };

  // ============================================
  // 3. PARCHEAR TODOS LOS VIDEOS
  // ============================================
  
  const patchAllVideos = () => {
    let patchedCount = 0;
    
    document.querySelectorAll('video').forEach(video => {
      // Remover autoplay de videos no visibles
      const rect = video.getBoundingClientRect();
      if (rect.top > window.innerHeight) {
        video.preload = 'none';
        video.removeAttribute('autoplay');
        patchedCount++;
      }
    });
    
    return patchedCount;
  };

  // ============================================
  // 4. PARCHEAR BACKGROUNDS CON IMÁGENES
  // ============================================
  
  const patchBackgroundImages = () => {
    let patchedCount = 0;
    
    document.querySelectorAll('[style*="background-image"]').forEach(el => {
      const rect = el.getBoundingClientRect();
      
      // Si está debajo del fold
      if (rect.top > window.innerHeight) {
        const bgImage = el.style.backgroundImage;
        el.style.backgroundImage = 'none';
        el.dataset.bg = bgImage.match(/url\(['"]?(.*?)['"]?\)/)?.[1];
        patchedCount++;
      }
    });
    
    return patchedCount;
  };

  // ============================================
  // 5. PARCHEAR PRODUCT CARDS
  // ============================================
  
  const patchProductCards = () => {
    let patchedCount = 0;
    
    document.querySelectorAll('.card-wrapper, .product-card-wrapper').forEach((card, index) => {
      // Skip primeros 6 productos
      if (index < 6) return;
      
      // Lazy load imágenes del producto
      card.querySelectorAll('img:not([loading="lazy"])').forEach(img => {
        img.loading = 'lazy';
        img.decoding = 'async';
        patchedCount++;
      });
    });
    
    return patchedCount;
  };

  // ============================================
  // 6. PARCHEAR SHOPIFY SECTIONS
  // ============================================
  
  const patchSections = () => {
    let patchedCount = 0;
    
    document.querySelectorAll('.shopify-section').forEach((section, index) => {
      // Skip primera sección (hero/banner)
      if (index === 0) return;
      
      // Agregar data-lazy para lazy loading de sección completa
      if (!section.hasAttribute('data-lazy')) {
        section.dataset.lazy = 'true';
        patchedCount++;
      }
    });
    
    return patchedCount;
  };

  // ============================================
  // 7. PARCHEAR PICTURE ELEMENTS
  // ============================================
  
  const patchPictureElements = () => {
    let patchedCount = 0;
    
    document.querySelectorAll('picture').forEach((picture, index) => {
      // Skip primeros 2
      if (index < 2) return;
      
      const img = picture.querySelector('img');
      if (img && img.loading !== 'lazy') {
        img.loading = 'lazy';
        img.decoding = 'async';
        patchedCount++;
      }
      
      // También las sources
      picture.querySelectorAll('source').forEach(source => {
        if (source.srcset && !source.dataset.srcset) {
          source.dataset.srcset = source.srcset;
          source.removeAttribute('srcset');
        }
      });
    });
    
    return patchedCount;
  };

  // ============================================
  // 8. PARCHEAR SLIDESHOW/CAROUSEL IMAGES
  // ============================================
  
  const patchCarouselImages = () => {
    let patchedCount = 0;
    
    document.querySelectorAll('.slideshow, .carousel, .slider').forEach(carousel => {
      carousel.querySelectorAll('img').forEach((img, index) => {
        // Solo primera slide carga eager
        if (index === 0) {
          img.loading = 'eager';
          img.fetchpriority = 'high';
        } else {
          img.loading = 'lazy';
          img.decoding = 'async';
          patchedCount++;
        }
      });
    });
    
    return patchedCount;
  };

  // ============================================
  // 9. PARCHEAR COLLECTION/BLOG IMAGES
  // ============================================
  
  const patchCollectionImages = () => {
    let patchedCount = 0;
    
    // Collection cards
    document.querySelectorAll('.collection-card, .article-card').forEach((card, index) => {
      if (index < 4) return; // Skip primeros 4
      
      card.querySelectorAll('img:not([loading="lazy"])').forEach(img => {
        img.loading = 'lazy';
        img.decoding = 'async';
        patchedCount++;
      });
    });
    
    return patchedCount;
  };

  // ============================================
  // 10. PARCHEAR MODAL/POPUP IMAGES
  // ============================================
  
  const patchModalImages = () => {
    let patchedCount = 0;
    
    document.querySelectorAll('dialog, .modal, .popup, [role="dialog"]').forEach(modal => {
      modal.querySelectorAll('img:not([loading="lazy"])').forEach(img => {
        img.loading = 'lazy';
        img.decoding = 'async';
        patchedCount++;
      });
    });
    
    return patchedCount;
  };

  // ============================================
  // 11. OPTIMIZAR SRCSET (Remover tamaños grandes innecesarios)
  // ============================================
  
  const optimizeSrcset = () => {
    let optimizedCount = 0;
    
    document.querySelectorAll('img[srcset]').forEach(img => {
      const rect = img.getBoundingClientRect();
      const maxWidth = Math.max(rect.width, img.width) * 2; // Retina
      
      if (maxWidth > 0) {
        const srcset = img.srcset.split(',').map(s => s.trim());
        const optimized = srcset.filter(src => {
          const width = parseInt(src.match(/(\d+)w$/)?.[1]);
          return !width || width <= maxWidth + 500; // Margen de 500px
        });
        
        if (optimized.length < srcset.length) {
          img.srcset = optimized.join(', ');
          optimizedCount++;
        }
      }
    });
    
    return optimizedCount;
  };

  // ============================================
  // 12. PARCHEAR SVG PLACEHOLDERS
  // ============================================
  
  const patchSVGPlaceholders = () => {
    let patchedCount = 0;
    
    document.querySelectorAll('.placeholder-svg').forEach(svg => {
      const parent = svg.parentElement;
      if (parent && parent.getBoundingClientRect().top > window.innerHeight) {
        parent.style.minHeight = '200px';
        parent.dataset.lazyPlaceholder = 'true';
        patchedCount++;
      }
    });
    
    return patchedCount;
  };

  // ============================================
  // EJECUTAR TODOS LOS PATCHES
  // ============================================
  
  const runAllPatches = () => {
    const results = {
      images: patchAllImages(),
      iframes: patchAllIframes(),
      videos: patchAllVideos(),
      backgrounds: patchBackgroundImages(),
      productCards: patchProductCards(),
      sections: patchSections(),
      pictures: patchPictureElements(),
      carousels: patchCarouselImages(),
      collections: patchCollectionImages(),
      modals: patchModalImages(),
      srcset: optimizeSrcset(),
      svgPlaceholders: patchSVGPlaceholders()
    };
    
    const total = Object.values(results).reduce((sum, val) => sum + val, 0);
    
    console.log('✅ Lazy Loading Patch completado:');
    console.log('  - Imágenes parcheadas:', results.images);
    console.log('  - Iframes parcheados:', results.iframes);
    console.log('  - Videos optimizados:', results.videos);
    console.log('  - Backgrounds lazy:', results.backgrounds);
    console.log('  - Product cards:', results.productCards);
    console.log('  - Secciones:', results.sections);
    console.log('  - Picture elements:', results.pictures);
    console.log('  - Carousels:', results.carousels);
    console.log('  - Collections:', results.collections);
    console.log('  - Modals:', results.modals);
    console.log('  - Srcset optimizados:', results.srcset);
    console.log('  - SVG placeholders:', results.svgPlaceholders);
    console.log('  --------------------------------');
    console.log('  🎯 TOTAL ELEMENTOS OPTIMIZADOS:', total);
    
    // Disparar evento custom
    document.dispatchEvent(new CustomEvent('lazyLoadingPatched', {
      detail: { results, total }
    }));
    
    return results;
  };

  // ============================================
  // RE-PATCHEAR EN CAMBIOS DINÁMICOS
  // ============================================
  
  const observeDynamicContent = () => {
    const observer = new MutationObserver((mutations) => {
      let shouldPatch = false;
      
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) { // Element node
              if (node.tagName === 'IMG' || 
                  node.tagName === 'IFRAME' ||
                  node.querySelector('img, iframe')) {
                shouldPatch = true;
              }
            }
          });
        }
      });
      
      if (shouldPatch) {
        // Debounce re-patch
        clearTimeout(window.lazyPatchTimeout);
        window.lazyPatchTimeout = setTimeout(() => {
          console.log('🔄 Re-parcheando contenido dinámico...');
          runAllPatches();
        }, 500);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  // ============================================
  // INICIALIZACIÓN
  // ============================================
  
  const init = () => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Ejecutar patches inmediatamente
    const results = runAllPatches();
    
    // Observar cambios dinámicos
    observeDynamicContent();
    
    // Exponer utilidad global
    window.lazyPatch = {
      run: runAllPatches,
      results: results,
      version: '2.0.0'
    };
    
    // Re-ejecutar en eventos de Shopify
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => {
        setTimeout(runAllPatches, 100);
      });
    }
  };

  init();

})();

// ============================================
// ESTILOS ADICIONALES PARA PATCHES
// ============================================

const patchStyles = document.createElement('style');
patchStyles.textContent = `
  /* Placeholder para backgrounds lazy */
  [data-lazy-placeholder="true"] {
    background-color: #f5f5f5;
    position: relative;
  }
  
  [data-lazy-placeholder="true"]::before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
  }
  
  @keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
  
  /* Optimización de re-layout */
  img[loading="lazy"]:not([width]) {
    min-height: 100px;
  }
  
  /* Smooth transitions */
  img[loading="lazy"] {
    transition: opacity 0.3s ease-in;
  }
`;

document.head.appendChild(patchStyles);

console.log('🚀 Lazy Loading Patch System v2.0 cargado');
